import { FlexProps } from "./types";
import * as S from "./styles";

const Flex = (props: FlexProps) => {
  return <S.Flex>{props.children}</S.Flex>;
};

export default Flex;
